<template>
  <div class="vue timparty-user-popup user-popup">
    <LoaderOverlay class="min-vh-100" v-if="loading"/>

    <basic-modal :modal-id="modal_id" :modal-class="modal.class_name"
                 :modal-style="user.popup_background_color ? 'background-color: '+ user.popup_background_color : ''"
                 class="modal-user-popup" :show="modal.show" v-on:modalClose="modal.show = false"
                 v-if="current_reward.notificationId && current_reward.templateCode == 'DEFAULT_POPUP'">
      <!--    <basic-modal :modal-id="modal_id" :modal-class="modal.class_name"-->
      <!--                 :modal-style="user.popup_background_color ? 'background-color: '+ user.popup_background_color : ''"-->
      <!--                 class="modal-user-popup" :show="modal.show" v-on:modalClose="modal.show = false"-->
      <!--                 v-if="current_reward.rewardId && rewardType !== 'popup_mgm'">-->

      <!-- TEMPLATE CODE: DEFAULT_POPUP -->
      <div class="modal-body modal-user-popup-start p-0" v-if="modal.state == 'start'">
        <div class="modal-user-popup-start-content ">
          <div class="d-sm-none">
            <img :src="images.mobile" class="img-fluid img-popup img-popup-mobile">
          </div>
          <div class="d-none d-sm-block d-xl-none">
            <img :src="images.tablet" class="img-fluid img-popup img-popup-tablet">
          </div>
          <div class="d-none d-xl-block">
            <img :src="images.desktop" class="img-fluid img-popup img-popup-desktop">
          </div>
          <div class="popup-actions px-4">
            <div v-if="rewardType == 'external'" class="text-center p-2">
              <!-- EXTERNAL -->
              <div class="row">
                <div class="col">
                  <a class="btn btn-white btn-block" @click="updatePopupData({reward_retrieved: 1})"
                     :href="current_reward.infoContent.url_cta + '?token=' + access_token" target="_blank">{{
                      buttonLabel
                    }}</a>
                  <!--                  <a class="btn btn-white btn-block" @click="updatePopupData({reward_retrieved: 1})"-->
                  <!--                     :href="current_reward.notification.url + '?token=' + access_token" target="_blank">{{-->
                  <!--                      buttonLabel-->
                  <!--                    }}</a>-->
                </div>
              </div>
            </div>

            <div v-else-if="rewardType == 'internal'" class="text-center p-2">
              <!-- INTERNAL -->
              <div class="row">
                <div class="col">
                  <a class="btn btn-white btn-block" @click="updatePopupData()"
                     :href="current_reward.infoContent.url_cta">{{ buttonLabel }}</a>
                </div>
              </div>
            </div>

            <div v-else-if="rewardType == 'catalog'" class="p-2">
              <div class="popup-email-danger">
                <span class=" text-danger" v-if="user_email_invalid">{{ __('Email non valida') }}</span>
              </div>

              <!-- CATALOG -->
              <div class="row">
                <div class="col-sm-4 offset-sm-2 py-2" v-if="emailRequired">
                  <div class="form-group mb-0">
                    <input type="text" class="form-control" v-model="user_email" :placeholder="__('Email')">
                  </div>
                </div>
                <div :class="emailRequired ? 'col-sm-4 py-2' : 'col-sm-8 offset-sm-2 py-2'">
                  <button class="btn btn-white btn-block" @click.prevent="showRetrieveModal">{{ buttonLabel }}</button>
                </div>
              </div>

            </div>
            <!--            <div v-else-if="rewardType == 'popup_mgm'" class="p-2"></div>-->


            <div v-if="prize" class="text-center popup-reward-details" v-html="prize.offerTitle"></div>
          </div>
        </div>
      </div>
      <div v-if="modal.state == 'confirm'">
        <div class="modal-body text-center pb-5">
          <div class=" p-2 reward-gift-icon">
            <IconGiftClosed/>
          </div>
          <h3 class="font-weight-bold ">{{ __('Il tuo vantaggio si avvicina... ci siamo quasi!') }}</h3>

          <div class="mt-4">

            <p>
              {{ __('Stai per richiedere ') }} <strong v-html="prize.title"></strong><br>
              <span v-if="emailRequired">
                        {{ __('Ti verrà inviato al tuo indirizzo di posta elettronica ') }}  <strong> {{
                  user_email
                }} </strong>
                      </span>
              <span v-else>
                        {{ __('Verrà attivato sulla tua linea telefonica ') }}  <strong> {{
                  user.loyalty_line
                }} </strong>
                      </span>

            </p>

            <div class="mt-4">
              <div class="row no-gutters">
                <div class="col-6 text-right px-1">
                  <button class="btn btn-outline-primary btn-lg" @click="modal.show = false">{{
                      __('ANNULLA')
                    }}
                  </button>
                </div>
                <div class="col-6 text-left px-1">
                  <button class="btn btn-primary btn-lg" @click="retrieveReward">{{ __('CONFERMA') }}</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div v-else-if="modal.state == 'retrieve_result'">
        <div class="modal-body text-center">
          <div class=" p-2 reward-gift-icon">
            <IconGiftOpen/>
          </div>
          <h3 class="font-weight-bold mt-4">{{ __('Congratulazioni') }}</h3>

          <div class="mt-4">

            <div v-if="emailRequired">
              <p class="mx-4">
                {{ __('Stiamo per inviare il vantaggio da te richiesto ') }} <strong
                v-html="prize.title"></strong> {{ __(' al tuo indirizzo di posta ') }} <strong> {{
                  user_email
                }} </strong><br>
                {{
                  __('A breve riceverai un\'e-mail con la conferma della tua richiesta e informazioni utili per l\'utilizzo del tuo vantaggio.')
                }}
              </p>
              <p>
                {{
                  __('Nell\'e-mail troverai tutte le informazioni necessarie per utilizzare subito il tuo vantaggio.')
                }}
              </p>
            </div>
            <div v-else>
              <p class="mx-4">
                {{ __('Stiamo per attivare il vantaggio da te richiesto ') }} <strong
                v-html="prize.title"></strong> {{ __(' sulla tua linea telefonica ') }} <strong>
                {{ user.loyalty_line }} </strong><br>
              </p>

            </div>

            <div class="mb-5">
              <button class="btn btn-primary btn-lg" @click="modal.show = false">{{ __('Chiudi') }}</button>
            </div>

          </div>

        </div>
        <div class="bg-dark p-5" v-if="user.flg_privacy_mail != '1'">
          <NewsletterBox/>
        </div>
      </div>
    </basic-modal>

    <basic-modal v-if="current_reward.notificationId && current_reward.templateCode == 'ICON_POPUP'"
                 :modal-id="modal.modal_id"
                 :modal-style="user.popup_background_color ? 'background-color: '+ user.popup_background_color : ''"
                 :modal-class="modal.class_name" class="modal-user-popup modal-dialog-centered" :show="modal.show"
                 v-on:modalClose="modal.show = false">
      <div class="modal-body p-5">
        <div class="text-center my-3">
          <!--          <img :src="modulePath('js/src/assets/images/portaunamico-amico.png')">-->
          <img :src="current_reward.infoContent.url_image">
        </div>
        <div>
          <div class="text-center my-4">
            <h3 class="text-dark mt-2 font-weight-bold" v-html="current_reward.infoContent.title"></h3>
          </div>
          <div class="text-center" v-html="current_reward.infoContent.description"></div>


          <div class="text-center my-4">
            <a id="link-badge" :href="current_reward.infoContent.url_cta" class="btn btn-lg btn-primary"
               v-text="current_reward.infoContent.label_cta"></a>
          </div>
        </div>
      </div>
    </basic-modal>

    <!--    NEWSLETTER POPUP-->
    <basic-modal v-if="current_reward.notificationId && current_reward.templateCode == 'NEWSLETTER_FORM_POPUP'"
                 :modal-id="modal.modal_id"
                 :modal-style="getStyleModal(user, current_reward)"
                 class="modal-user-popup modal-dialog-centered newsletter-popup"
                 :modal-class="'newsletter-popup-width'"
                 :show="modal.show"
                 v-on:modalClose="modal.show = false">
      <div class="modal-body px-lg-5 pt-5 pb-lg-0">
        <div>
          <div class="text-center my-2">
            <h3 class="text-dark mt-2 font-weight-bold" v-html="current_reward.infoContent.title"></h3>
            <img class="newsletter-reward-icon" :style="current_reward.infoContent.css_reward_image" :src="current_reward.infoContent.url_reward_image">
          </div>
          <div class="text-center" v-html="current_reward.infoContent.description"></div>
<!--          <div class="text-center"><p class="newsletter-popup-description">Ti regaliamo subito<br/><span class="newsletter-popup-description-bold">IL 25% DI SCONTO <br/>SU NORTH SAILS</span></p><p class="newsletter-popup-description-footnote">*Valido solo sul full price</p></div>-->

          <!-- START FORM -->
          <div class="form mt-2 row">

            <div :class="'form-group text-left col-12 col-md-8 offset-md-2 align-self-center'">
              <!--              <input type="text" :class="'form-control '  + (validation_errors.email ? 'border-danger' : '')" :style="'border-radius: 15px;'" v-model="user_email">-->
              <input type="text" :class="'form-control bg-transparent text-white'" :style="'border-radius: 8px; height: 48px;'"
                     v-model="user_email" placeholder="E-mail" :disabled="newsletter.disabled">
            </div>
            <div class="col-12 col-md-8 offset-md-2">
                <!--<button class="btn btn-primary btn-block" :disabled="!formValid" @click.prevent="submitForm(true)">{{ __('Invia') }}</button>-->
                <button class="btn btn-white btn-block" :style="'border-radius: 8px; height: 45px;'"
                        @click.prevent="submitNewsletterForm(true)" :disabled="newsletter.disabled">{{
                    __('ISCRIVITI')
                  }}
                </button>
                <div v-if="newsletter.alert.message" class="mt-3" :class="newsletter.alert.class_name"
                     v-html="newsletter.alert.message" :role="newsletter.alert.role"></div>
            </div>
            <div class="col-12">
              <p class="newsletter-popup-disclaimer mt-3">Continuando con la richiesta, dichiari di aver letto e compreso l’<a v-if="user" :href="user.news_privacy_policy_url" target="_blank">Informativa Privacy</a> del servizio Newsletter.</p>
            </div>
          </div>
          <!-- END FORM -->
        </div>
      </div>
    </basic-modal>


    <!-- MODAL ERROR / BEGIN -->
    <ErrorModal :error="error" v-on:modalClose="error = null"/>
    <!-- MODAL ERROR / END -->


  </div>
</template>

<script>

/* eslint-disable */

import $ from 'jquery';

import TimPartyMixin from '../mixins/TimPartyMixin';
import BasicModal    from './BasicModal.vue'
import ErrorModal    from './ErrorModal.vue'
import LoaderOverlay from './LoaderOverlay.vue'
import moment        from 'moment';

import ArrowLeft      from '../assets/images/arrow-white-left.svg';
import ArrowRight     from '../assets/images/arrow-white-right.svg';
import IconGiftOpen   from '../assets/images/icon-gift-open.svg';
import IconGiftClosed from '../assets/images/icon-gift-closed.svg';

export default {
  name: 'UserPopup',
  mixins: [TimPartyMixin],
  components: {BasicModal, ErrorModal, LoaderOverlay, ArrowLeft, ArrowRight, IconGiftOpen, IconGiftClosed},
  props: {
    accessToken: String

  },
  data: function () {

    return {
      current_reward: {},
      modal: {
        id: 'modal-user-popup',
        show: false,
        class_name: 'modal-user-popup modal-xl',
        state: null,
        error: null
      },
      images: {},
      user_email: '',
      user_email_invalid: false,
      enablePopup: null,
      user_mgm: '',
      itemIDmgm: 0,
      prize: {},
      newsletter: {
        disabled: false,
        txt: {
          form_validation_error_title: 'Errore nella compilazione del modulo',
          form_validation_error_summary: 'Si prega di verificare i campi indicati',
          form_validation_email_error: 'Email non valida',

          result_message_success_new: 'La tua iscrizione alla Newsletter è avvenuta con successo!',
          result_message_success_edit: 'La modifica alla tua iscrizione alla Newsletter è avvenuta con successo.',
          result_message_error: 'Errore nel salvataggio dei dati'
        },
        alert: {
          class_name: '',
          message: '',
          role: ''
        }
      }
    };
  },
  mounted: function () {
    // console.log('UserPopup started');
  },

  methods: {
    checkForUserReward: function () {
      let self = this;

      if (this.enablePopup) {
        this.getReward(function () {
          // if (self.current_reward.rewardId && self.current_reward.redimible) {
          self.updatePopupData();

          self.modal.show  = true;
          self.modal.state = 'start';

          self.images.mobile = (self.current_reward.extra.images['popup-mobile'] != undefined ? self.current_reward.extra.images['popup-mobile'][0] : (self.current_reward.extra.images['popup-tablet'] != undefined ? self.current_reward.extra.images['popup-tablet'][0] : null));

          self.images.tablet = (self.current_reward.extra.images['popup-tablet'] != undefined ? self.current_reward.extra.images['popup-tablet'][0] : (self.current_reward.extra.images['popup-desktop'] != undefined ? self.current_reward.extra.images['popup-desktop'][0] : null));

          self.images.desktop = (self.current_reward.extra.images['popup-desktop'] != undefined ? self.current_reward.extra.images['popup-desktop'][0] : (self.current_reward.extra.images['popup-tablet'] != undefined ? self.current_reward.extra.images['popup-tablet'][0] : null));
          // }

        });

        // this.getReward(function () {
        //
        //
        //   if (self.current_reward.rewardId && self.current_reward.redimible) {
        //     self.updatePopupData();
        //
        //     self.modal.show  = true;
        //     self.modal.state = 'start';
        //
        //     self.images.mobile = (self.current_reward.extra.images['popup-mobile'] != undefined ? self.current_reward.extra.images['popup-mobile'][0] : (self.current_reward.extra.images['popup-tablet'] != undefined ? self.current_reward.extra.images['popup-tablet'][0] : null));
        //
        //     self.images.tablet = (self.current_reward.extra.images['popup-tablet'] != undefined ? self.current_reward.extra.images['popup-tablet'][0] : (self.current_reward.extra.images['popup-desktop'] != undefined ? self.current_reward.extra.images['popup-desktop'][0] : null));
        //
        //     self.images.desktop = (self.current_reward.extra.images['popup-desktop'] != undefined ? self.current_reward.extra.images['popup-desktop'][0] : (self.current_reward.extra.images['popup-tablet'] != undefined ? self.current_reward.extra.images['popup-tablet'][0] : null));
        //   }
        //
        //
        // });
      }
      else {
        // console.log( 'NOT getting Reward lv ' + this.user.popup_last_view + ' diff ' + diff + '  interval  ' +  this.user.popup_view_interval );
      }
    },
    updatePopupData: function () {
      var payload = {
        action: 'setLastSeenNotification',
        notification_id: this.current_reward.notificationId
      };

      this.setApiUrl(this.user.endpoints.user);

      this.callApi(payload, function (response) {
        console.log('updatePopupLastView', response);
      });
    },

    updatePopupDataOld: function (payload) {

      var self = this;

      var popup_data = {
        'reward_id': this.user_mgm != '' ? this.itemIDmgm : this.user.popup_reward_id,
        'viewed_at': moment().format('X')
      };
      if (this.user_mgm != '') {
        popup_data = {
          ...popup_data,
          'itemIDmgm': this.itemIDmgm,
          'user_mgm': this.user_mgm
        }
      }

      if (payload) {

        popup_data = {
          ...popup_data,
          ...payload
        }

      }

      var payload = {
        action: 'updatePopupData',
        popup_data: popup_data
      };


      this.setApiUrl(this.user.endpoints.user);
      this.callApi(payload, function (response) {

        console.log('updatePopupLastView', response);


      });
    },

    getReward: function (callback) {
      if (this.notifications.POPUP !== 'undefined' && this.notifications.POPUP[0] !== 'undefined') {
        this.current_reward = this.notifications.POPUP[0];
      }
      if (callback) {
        callback();
      }
    },

    getPrize: function (callback) {

      var self = this;

      var payload = {
        action: 'getReward',
        access_token: this.user.access_token, // '',
        reward_id: this.current_reward.infoContent.reward_id
      };


      self.loading = true;
      this.setApiUrl(this.user.endpoints.catalog);
      this.callApiGet(payload, function (response) {

        console.log('Reward', response);

        self.loading = false;

        if (response.data.rewardId != undefined && response.data.rewardId) {
          self.prize = response.data;
        }

        if (callback) {
          callback();
        }

      });
    },

    getRewardOld: function (callback) {

      var self = this;

      var payload = {
        action: 'getReward',
        access_token: this.user.access_token, // '',
        reward_id: this.user_mgm != '' ? this.itemIDmgm : this.user.popup_reward_id
      };


      self.loading = true;
      this.setApiUrl(this.user.endpoints.catalog);
      this.callApiGet(payload, function (response) {

        console.log('Reward', response);

        self.loading = false;

        if (response.data.rewardId != undefined && response.data.rewardId) {
          self.current_reward = response.data;
        }

        if (callback) {
          callback();
        }

      });
    },

    showRetrieveModal: function () {

      this.user_email = this.user_email.trim();

      if (this.emailRequired && !this.checkEmail(this.user_email)) {


        this.user_email_invalid = true;

        return;
      }

      this.user_email_invalid = false;

      this.modal.show  = true;
      this.modal.state = 'confirm';
    },

    retrieveReward: function () {
      var self = this;

      self.modal.show = false;

      var payload = {
        action: 'retrieveReward',
        access_token: this.access_token,
        reward: this.prize,
        email: this.user_email
      };

      self.loading = true;

      this.setApiUrl(self.user.endpoints.catalog);

      this.callApi(payload, function (response) {

        self.loading = false;


        if (response.success) {//

          self.modal.show  = true;
          self.modal.state = 'retrieve_result';


          self.updatePopupData({reward_retrieved: 1})

          self.gtmEvent({
            event: 'redeemVantaggi',
            eventCategory: 'Redeem Vantaggi',
            eventAction: 'Success’,',
            eventLabel: self.prize.title
          });

        }
        else {
          self.error = {
            title: 'Si è verificato un errore nella richiesta',
            content: response.detail != undefined ? response.detail : ''
          };
        }

      });
    },

    getStyleModal: (user, current_reward) => {
      let $style = '';
      if (current_reward.templateCode === 'NEWSLETTER_FORM_POPUP') {
        $style += 'background-image: url("' + current_reward.infoContent.url_bg_image + '");';
        $style += 'border-radius: 15px;';
        $style += 'position: relative !important;';
        $style += 'background-repeat: no-repeat;';
        $style += 'background-size: cover;';
        $style += 'background-position: center;';
        $style += 'color: ' + current_reward.infoContent.text_color + ';';
        $style += user.popup_background_color ? ' background-color: ' + user.popup_background_color + ';' : '';
      }
      return $style;
    },

    enablePopupFunction: function () {
      let enable_popup = true;
      if (this.user.flag_notification_login === '0') {
        enable_popup = false;
      }
      if (typeof this.notifications.POPUP !== 'undefined') {
        if (typeof this.notifications.POPUP[0] !== 'undefined') {
          if (this.notifications.POPUP[0].notificationId === null) {
            enable_popup = false;
          }
        } else {
          enable_popup = false;
        }
      } else {
        enable_popup = false;
      }
      this.enablePopup = enable_popup;
      return this.enablePopup;
    },

    enablePopupFunctionOld: function () {
      var self = this;

      //LOGICA MGM

      if (typeof this.getCookie("Drupal.visitor.popup") !== 'undefined' && this.getCookie("Drupal.visitor.popup") == '1') {
        return false;
      }

      var payload = {
        action: 'getMGMPopup'
      };

      this.setApiUrl('/api/mgm/handleAction');
      this.callApi(payload, function (response) {
        if (response.success) {
          self.user_mgm  = response.data.userType;
          self.itemIDmgm = response.data.inventoryItemId;
          return self.enablePopup = !response.data.alreadyShown
        }
        else {
          var last_reward_id = self.user.popup_user_data.reward_id ? self.user.popup_user_data.reward_id : 0;

          // se non ho il reward id non posso mostrare il popup
          if (!self.user.popup_reward_id) {
            console.log('se non ho il reward id non posso mostrare il popup');
            return self.enablePopup = false;
          }


          // se l'ultimo popup è diverso dal corrente mostro comunque il popup
          if (self.user.popup_reward_id != last_reward_id) {
            console.log("se l'ultimo popup è diverso dal corrente mostro comunque il popup");
            return self.enablePopup = true;
          }

          // se il prodotto è gia stato richiesto non mostro il popup
          if (self.user.popup_user_data.reward_retrieved) {
            console.log('se il prodotto è gia stato richiesto non mostro il popup');
            return self.enablePopup = false;
          }

          // verifico che sia passato il tempo minimo richiesto tra una visualizzazione e l'altra
          var viewed_at = self.user.popup_user_data.viewed_at ? self.user.popup_user_data.viewed_at : 0;
          var diff      = moment().diff(moment(viewed_at, 'X'), 'hours');
          return self.enablePopup = diff >= self.user.popup_view_interval;
        }
      });
    },

    submitNewsletterForm: function (is_new) {
      let self = this;

      if (!this.checkEmail(this.user_email.trim())) {

        self.newsletter.alert.class_name = 'text-danger';
        self.newsletter.alert.message    = self.newsletter.txt.form_validation_email_error;
        self.newsletter.alert.role       = 'failure';
        return;
      }

      self.newsletter.disabled = true;
      this.aaEvent('click', {
        form: {
          click: "Invia newsletter"
        }
      });

      let payload = {
        action: 'subscribeToNewsletter',
        access_token: this.access_token,
        data: {
          email: this.user_email
        }
      };

      this.loading = true;
      this.callApi(payload, function (response) {
        self.loading = false;

        if (response.success) {

          self.newsletter.alert.class_name = 'text-accent strong';
          self.newsletter.alert.message    = is_new ? self.newsletter.txt.result_message_success_new : self.newsletter.txt.result_message_success_edit;
          self.newsletter.alert.role       = 'success';
          self.newsletter.disabled         = true;
        }
        else {
          self.newsletter.alert.class_name = 'text-danger';
          self.newsletter.alert.message    = self.newsletter.txt.result_message_error;
          self.newsletter.alert.role       = 'failure';
          self.newsletter.disabled         = false;
        }

      });
    }
  },
  computed: {

    rewardType: function () {
      if (this.current_reward.templateCode == 'DEFAULT_POPUP' && this.current_reward.infoContent.type.toLowerCase() == 'external') {
        if (this.current_reward.infoContent.url_cta) {
          return 'external';
        }
        else {
          return null;
        }
      }
      else if (this.current_reward.templateCode == 'DEFAULT_POPUP' && this.current_reward.infoContent.type.toLowerCase() == 'internal') {
        if (this.current_reward.infoContent.url_cta) {
          return 'internal';
        }
        else {
          return null;
        }
      }
      else if (this.current_reward.templateCode == 'DEFAULT_POPUP' && this.current_reward.infoContent.type.toLowerCase() == 'catalog') {
        return 'catalog';
      }
      else {
        return null;
      }
    },

    emailRequired: function () {
      // return this.current_reward.infoContent.type != 'TIM';
      return !!(this.current_reward.templateCode === 'DEFAULT_POPUP' && this.current_reward.infoContent.type === 'CATALOG' && typeof this.current_reward.infoContent.emailRequired != undefined && this.current_reward.infoContent.emailRequired);
    },

    buttonLabel: function () {
      return this.user.popup_cta_label ? this.user.popup_cta_label : this.__('Richiedi');
    }
  },
  watch: {
    enablePopup: function () {
      this.checkForUserReward();
    },
    notifications() {
      this.enablePopupFunction();
    },
    current_reward() {
      if (this.current_reward.templateCode === 'NEWSLETTER_FORM_POPUP') {
        return;
      }
      this.getPrize();
    },
    prize() {
    },
    newsletter() {
      console.log('this.newsletter', this.newsletter);
    },
    modal() {
      console.log('watch modal', this.modal);
      this.$forceUpdate();
    }
  }
}
</script>

<style lang="scss">
//@import "../../../../../../themes/custom/timparty/scss/timparty/UserPopup/newsletter-form-popup";

</style>
